"use client"

import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../redux"
import { thunks } from "@/lib/redux/thunks"
import { useSearchParams } from "next/navigation"
import { useStoreSlug } from "./useStoreSlug"

const refCalledFetchStore: { current: any } = { current: null }

export const useStoreData = () => {
  // const dispatch = useAppDispatch()

  // const called = useAppSelector(state => state.store.store_setting.called)
  const data = useAppSelector(state => state.store.store_setting.data)

  // const { slug: storeSlug } = useStoreSlug()

  // const searchParams = useSearchParams()

  // useEffect(() => {
  //   if (!refCalledFetchStore.current && !called) {
  //     refCalledFetchStore.current = true

  //     const mmfUuid = searchParams.get("mf_uuid") || ""

  //     dispatch(thunks.store_setting({
  //       params: {
  //         slug: storeSlug,
  //         mmf_uuid: mmfUuid
  //       }
  //     }))
  //   }
  // }, [storeSlug])

  return { store: data }
}